<template>
  <div>
    <v-btn
      style="position: absolute; top: 0; z-index: 2000"
      v-if="absolute"
      text
      color="black"
      @click.stop="drawer = !drawer"
    >
      <v-icon>
        mdi-menu
      </v-icon>
    </v-btn>
    <v-navigation-drawer
      class="d-print-none"
      v-model="drawer"
      :right="right"
      :permanent="permanent"
      :absolute="absolute"
      :temporary="temporary"
      mobile-breakpoint="600"
      app
      v-bind:width="300"
    >
      <h1 class="py-7 px-4 text-uppercase font-poppins-heading font-weight-bold" style="color: var(--v-darkGreen-base)">VegaMenu</h1>
      <div class="d-flex text-readex justify-center mb-5">
        <v-icon>fa-credit-card</v-icon>
        <div class="ml-3">
          <span class="font-weight-bold" style="font-size: 1.1em">{{currentUser.credit}} Kč</span><br>
          <router-link class="text-darkGreen text-decoration-none" :to="{name: 'user.credit'}" style="font-size: 0.9em">Dobít kredit</router-link>
        </div>
      </div>
      <v-divider class="mb-8"></v-divider>
      <v-list
        dense
        nav
        rounded
      >
        <div
          v-for="(item, index) in items"
          :key="index">
          <v-list-item
            class="py-1"
            link
            :to="{name: `user.${item.linkName}`}"
          >
            <v-list-item-icon>
              <v-icon small>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
        <v-list-item
          link
          @click="logout"
          :disabled="$route.name === 'user.orders'"
        >
          <v-list-item-icon>
            <v-icon color="red" small>fa-power-off</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title style="color: red">Odhlásit se</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'NavBar',
  data () {
    return {
      drawer: true,
      items: [
        { title: 'Dashboard', icon: 'fa-house', linkName: 'dashboard' },
        { title: 'Objednávky', icon: 'fa-bag-shopping', linkName: 'orderHistory' },
        { title: 'Nová objednávka', icon: 'fa-circle-plus', linkName: 'orders' },
        { title: 'Správa strávníků', icon: 'fa-users', linkName: 'institution' }

      ],
      right: false,
      background: false
    }
  },
  methods: {
    logout () {
      this.$http.post('/logout')
        .then(response => {
          this.$store.commit('user/clearUserData')
          this.$router.push({ name: 'login' })
        })
        .catch(err => {
          console.log(err)
        })
    },
    initialize () {
      this.$http.get(`/users/${this.currentUser.id}`)
        .then(response => {
          this.updateCredit(response.data.credit)
        })
    },
    hide (alert) {
      alert.visible = false
    },
    ...mapMutations({ updateCredit: 'user/updateCredit' })
  },
  computed: {
    absolute () {
      return window.innerWidth < 600
    },
    temporary () {
      return window.innerWidth < 600
    },
    permanent () {
      return window.innerWidth > 600
    },
    expandOnHover () {
      return window.innerWidth > 600
    },
    miniVariant () {
      return window.innerWidth > 600
    },
    ...mapGetters({ currentUser: 'user/currentUser' })
  },
  created () {
    this.initialize()
  }
}
</script>

<style scoped>
a{
  color: #ffffff;
}
  .cursor{
    cursor: pointer;
  }
  .v-list{
    width: 80%;
    margin: auto;
  }
  .v-list-item__content{
  }
  >>>.v-list-item__icon{
    margin: auto !important;
    margin-left: 5px !important;
    margin-right: 15px !important;
  }
  >>>.v-list-item--active{
    background-color: var(--v-darkGreen-base);
    color: white;
  }
</style>
